import { ExternalCatalogPackageVersion } from "Types";
import * as yup from "Utils/yup";
import { ImportableVersion } from "./types";

export const getImportableVersions = (
  versions: ExternalCatalogPackageVersion[],
  artifactsFilter: {
    platform: string;
    architecture: string;
    extension: string;
  },
): ImportableVersion[] =>
  versions.flatMap((version) =>
    version.artifacts
      .filter(
        (artifact) =>
          artifact.platform === artifactsFilter.platform &&
          artifact.architecture === artifactsFilter.architecture &&
          artifact.extension.toLowerCase() ===
            artifactsFilter.extension.toLowerCase(),
      )
      .map((artifact) => ({
        version: version.version,
        released: artifact.released,
        size: artifact.size,
      })),
  );

export const getSelectionSize = (
  versions: ImportableVersion[],
  selected: (string | undefined)[],
): number =>
  versions
    .filter((item) => selected.includes(item.version))
    .reduce((sum, item) => sum + item.size, 0);

export const getVersionsSelectionSchema = (
  versions: ImportableVersion[],
  remainingCapacity: number,
  maxVersions: number,
): yup.SchemaOf<string[]> =>
  yup
    .array()
    .of(yup.string().required())
    .min(1, "Select at least one version")
    .max(maxVersions, `Select at most ${maxVersions} versions`)
    .test(
      "capacity",
      "Selected versions exceed the remaining analysis capacity",
      (selected) =>
        getSelectionSize(versions, selected ?? []) <= remainingCapacity,
    )
    .required();
